export const TOPIC_API_ROUTES = {
  GET_TOPIC: "admin/topic",
  GET_TOPIC_BY_ID: "admin/topic/:id",
  CREATE_TOPIC: "admin/topic",
  UPDATE_TOPIC: "admin/topic/:id",
  DELETE_TOPIC: "admin/topic/:id",
};
